import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEdit = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	stroke: "currentColor",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M13.3333 8.00008V14.0001C13.3333 14.3667 13.0333 14.6667 12.6667 14.6667H1.99999C1.63333 14.6667 1.33333 14.3667 1.33333 14.0001V3.33341C1.33333 2.96675 1.63333 2.66675 1.99999 2.66675H8",
		strokeWidth: 1.2,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12.7667 1.58665L6.15999 8.19332L5.33333 10.6667L7.80666 9.83999L14.4133 3.23332C14.7133 2.93332 14.7533 2.47332 14.4933 2.21332L13.7867 1.50665C13.5267 1.24665 13.0667 1.27999 12.7667 1.58665Z",
		strokeWidth: 1.2,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgEdit;
